import React from "react";
import loader from "../../img/loader.svg";

function Loader() {
  return <img src={loader} alt="loading..." />;
}

export default Loader;
